module.exports = __webpack_public_path__ + "img/4LNG_Cover.fa0a1d97.jpg";